import React from "react"

export const useTicker = (isActive: boolean, interval = 1_000): void => {
  const [, setTick] = React.useState(0)

  React.useEffect(() => {
    if (!isActive) return
    const id = setInterval(() => setTick((t) => t + 1), interval)
    return () => clearInterval(id)
  }, [isActive, interval])
}
